import { render } from "./QwButtonDanger.vue?vue&type=template&id=4ec67f68"
import script from "./QwButtonDanger.vue?vue&type=script&lang=js"
export * from "./QwButtonDanger.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__